module.exports = __webpack_public_path__ + "img/pause.31b7654b.svg";